const gridJson = require('customtheme.json').grid;

export const grid = {
  space1: '8px',
  space2: '16px',
  space3: '24px',
  ...gridJson,
};
